export const SET_OPERATION_PROPERTY = 'SET_OPERATION_PROPERTY';
export const ADD_CONTACT_PROSPECT = 'ADD_CONTACT_PROSPECT';
export const DELETE_CONTACT_PROSPECT = 'DELETE_CONTACT_PROSPECT';
export const COPY_DATA_CONTACT_TO_ATTORNEY = 'COPY_DATA_CONTACT_TO_ATTORNEY';
export const SET_CUSTOMER_TYPE_OPERATION = 'SET_CUSTOMER_TYPE_OPERATION';
export const RESET_OPERATION_DATA = 'RESET_OPERATION_DATA';
export const CREATE_NEW_OPERATION = 'CREATE_NEW_OPERATION';
export const CREATE_OPERATION_DATA_TO_SEND = 'CREATE_OPERATION_DATA_TO_SEND';
export const RESEND_EMAIL = 'RESEND_EMAIL';
export const GOTO_AMZ = 'GOTO_AMZ';
export const GOTO_DIGITAL_CONTRACT = 'GOTO_DIGITAL_CONTRACT';
export const CANCEL_OPERATION = 'CANCEL_OPERATION';
export const NOT_INTERESTED_OPERATION = 'NOT_INTERESTED_OPERATION';
export const DELETE_DATA_TO_SEND = 'DELETE_DATA_TO_SEND';
export const SET_TO_MANUAL_STUDY = 'SET_TO_MANUAL_STUDY';
export const OPERATION_SAVE_HOLDER_MOBILE = 'OPERATION_SAVE_HOLDER_MOBILE';
export const OPERATION_SEND_SMS = 'OPERATION_SEND_SMS';
export const RESEND_SIGNATURE = 'RESEND_SIGNATURE';
export const CREATION_PROSPECT_RISK = 'CREATION_PROSPECT_RISK';
export const RESET_PROSPECTB2B_DATA = 'RESET_PROSPECTB2B_DATA';
export const PROSPECT_GET_RISKS = 'PROSPECT_GET_RISKS';
export const PROSPECT_CANCEL_OPERATION = 'PROSPECT_CANCEL_OPERATION';
export const CANCEL_NEW_OPERATION_ACTIVE_B2C = 'CANCEL_NEW_OPERATION_ACTIVE_B2C';
